(function() {
  'use strict';

  /* =============================================
     Scroll Reveal — IntersectionObserver
     ============================================= */

  var revealElements = document.querySelectorAll('.reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  /* =============================================
     Back to Top
     ============================================= */

  var backToTopBtn = document.getElementById('back-to-top');
  if (backToTopBtn) {
    var footer = document.querySelector('.footer');
    var footerIsVisible = false;

    function updateBackToTop() {
      if (window.scrollY > 500 && !footerIsVisible) {
        backToTopBtn.classList.add('is-visible');
        backToTopBtn.style.display = 'flex';
      } else {
        backToTopBtn.classList.remove('is-visible');
        backToTopBtn.style.display = 'none';
      }
    }

    window.addEventListener('scroll', updateBackToTop, { passive: true });

    if (footer && 'IntersectionObserver' in window) {
      var footerObserver = new IntersectionObserver(function(entries) {
        footerIsVisible = entries[0].isIntersecting;
        updateBackToTop();
      });
      footerObserver.observe(footer);
    }

    updateBackToTop();

    backToTopBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
